window.NifticQueryInterface = class {
  constructor(permalink, element) {
    this.permalink = permalink;
    this.element = element;
    this.dropdowns = this.element.querySelectorAll('[data-niftic-dropdown]');
    this.selects = this.element.querySelectorAll('select[data-niftic-select]');
    this.tmpSelects = this.element.querySelector('.temp-select-location');
    this.searchInput = this.element.querySelector('input#search-box');
    this.resultsArea = this.element.querySelector('[data-niftic-results]');
    this.currentCount = this.element.querySelector('.current-page-count');
    this.paginationArea = this.element.querySelector('.niftic-pagination-controls');
    this.addEventListeners();
    this.ajaxifyLinks();
  }

  addEventListeners() {
    this.dropdowns.forEach(dropdown => {
      const button = dropdown.querySelector('button');
      if (button) {
        button.addEventListener('click', event => {
          dropdown.querySelector('.filter-dropdown').classList.toggle('show');
        });
        dropdown.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
          checkbox.addEventListener('change', event => {
            this.eventLoad();
          });
        });
        const checked = dropdown.querySelectorAll('input:checked').length;
        button.dataset.activeChildren = checked;
      }
    });

    this.selects.forEach(select => {
      this.resizeSelect(select);
      select.addEventListener('change', event => {
        this.eventLoad();
        this.resizeSelect(select);
      });
    });

    this.searchInput.addEventListener('keyup', e => {
      if ('Enter' === e.key || 13 === e.keyCode) {
        this.eventLoad();
      }
    });

    document.addEventListener('click', event => {
      this.dropdowns.forEach(dropdown => {
        if (
          dropdown.querySelector('.filter-dropdown') &&
          dropdown.querySelector('.filter-dropdown').classList.contains('show') &&
          dropdown.querySelector('.filter-dropdown') !== event.target &&
          !dropdown.contains(event.target)
        ) {
          dropdown.querySelector('.filter-dropdown').classList.remove('show');
        }
      });
    });
  }

  copyNodeStyle(sourceNode, targetNode) {
    const computedStyle = window.getComputedStyle(sourceNode);
    Array.from(computedStyle).forEach(function(key) {
      return targetNode.style.setProperty(
        key,
        computedStyle.getPropertyValue(key),
        computedStyle.getPropertyPriority(key)
      );
    });
  }

  resizeSelect(select) {
    const name = select.name;
    if (!this.tmpSelects.querySelector('select[data-select-name="' + name + '"]')) {
      const newTempSelect = document.createElement('select');
      newTempSelect.dataset.selectName = name;
      newTempSelect.innerHTML = '<option>' + select.value + '</option>';
      newTempSelect.classList.add('tmp_select', 'mbn');
      this.tmpSelects.appendChild(newTempSelect);
    }
    const temp = this.tmpSelects.querySelector('select[data-select-name="' + name + '"]');
    temp.innerHTML = '<option>' + select.value + '</option>';
    select.style.width = temp.clientWidth + 'px';
  }

  makeRequest(type, url, data, callback) {
    const classInstance = this;
    const newXHR = new XMLHttpRequest() || new window.ActiveXObject('Microsoft.XMLHTTP');
    newXHR.open(type, url, true);
    newXHR.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    newXHR.send(data);
    newXHR.onreadystatechange = function() {
      if (200 === this.status && 3 < this.readyState) {
        callback(classInstance, this.response);
      }
    };
  }

  updateQueryStringParameter(uri, key, value) {
    const re = new RegExp('([?&])' + key + '=.*?(&|#|$)', 'i');
    if (value === undefined) {
      if (uri.match(re)) {
        return uri
          .replace(re, '$1$2')
          .replace(/[?&]$/, '')
          .replaceAll(/([?&])&+/g, '$1')
          .replace(/[?&]#/, '#');
      }
      return uri;
    }
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    }
    let hash = '';
    if (-1 !== uri.indexOf('#')) {
      hash = uri.replace(/.*#/, '#');
      uri = uri.replace(/#.*/, '');
    }
    const separator = -1 !== uri.indexOf('?') ? '&' : '?';
    return uri + separator + key + '=' + value + hash;
  }
  addUrlParams(ajaxLink = this.permalink) {
    this.dropdowns.forEach(dropdown => {
      const query = dropdown.dataset.nifticQuery;
      const checked = dropdown.querySelectorAll('input:checked');
      const button = dropdown.querySelector('button');
      if (checked.length) {
        ajaxLink = this.updateQueryStringParameter(
          ajaxLink,
          query,
          Array.from(checked)
            .map(e => e.value)
            .join(' ')
        );
        if (button) {
          dropdown.querySelector('button').classList.add('active');
          dropdown.querySelector('button').dataset.activeChildren = checked.length;
        }
      } else if (button) {
        dropdown.querySelector('button').classList.remove('active');
        dropdown.querySelector('button').dataset.activeChildren = 0;
      }
    });
    this.selects.forEach(select => {
      const query = select.dataset.nifticQuery;
      const value = select.value;
      ajaxLink = this.updateQueryStringParameter(ajaxLink, query, value);
    });
    if (this.searchInput.value) {
      ajaxLink = this.updateQueryStringParameter(ajaxLink, 'search', this.searchInput.value);
    }
    // Update URL before adding JSON parameter
    window.history.pushState(
      {
        path: ajaxLink
      },
      document.title,
      ajaxLink
    );
    ajaxLink = this.updateQueryStringParameter(ajaxLink, 'json', 'true');
    return ajaxLink;
  }

  ajaxifyLinks() {
    const links = this.paginationArea.querySelectorAll('a:not([data-ajax-listened])');
    links.forEach(link => {
      link.href = this.updateQueryStringParameter(link.href, 'json', '');
      link.addEventListener('click', event => {
        event.preventDefault();
        const target = event.target;
        if (target.href) {
          const ajaxLink = this.addUrlParams(target.href);
          this.loadBuffer();
          this.makeRequest('GET', ajaxLink, '', this.loadNewEntries);
        }
      });
      link.dataset.ajaxListened = true; // Mark as listened
    });
  }

  loadBuffer() {
    this.resultsArea.style.height = this.resultsArea.clientHeight + 'px';
    this.resultsArea.innerHTML =
      '<div class="col-12 loader-col"><div class="loading-area"><div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div></div>';
    /*document.querySelector('.main-header').scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });*/
  }

  eventLoad(scroll = false) {
    const ajaxLink = this.addUrlParams(this.permalink);
    this.loadBuffer();
    this.makeRequest('GET', ajaxLink, '', this.loadNewEntries);
  }

  loadNewEntries(that, data) {
    that.resultsArea.style.height = 'auto';
    data = JSON.parse(data);
    if (data.search) {
      that.searchInput.value = data.search;
    }
    /*if (data['active-topics'] !== "") {
            that.topicSelected.innerHTML = '<div class="vam"><span class="mobile-hide-fully">Filter by: </span>'+ data['active-topics'] +'</div>';
        } else {
            that.topicSelected.innerHTML = '';
        }*/
    //that.currentCount.innerHTML = data.total;
    that.paginationArea.innerHTML = data.pagination;
    /*if(document.querySelectorAll(that.topicCheck).length > 0) {
            document.getElementById('filter-by-topic').classList.add('active');
        } else {
            document.getElementById('filter-by-topic').classList.remove('active');
        }
        if(document.querySelectorAll(that.yearCheck).length > 0) {
            document.getElementById('filter-by-year').classList.add('active');
        } else {
            document.getElementById('filter-by-year').classList.remove('active');
        }*/

    that.ajaxifyLinks();
    that.resultsArea.innerHTML = '';
    data.results.forEach(element => (that.resultsArea.innerHTML += element));
    /*document.querySelectorAll(that.unselectTopics).forEach((cb) => {
            cb.addEventListener('click', () => {
                document.querySelector('input[type="checkbox"][value="'+ cb.dataset.topic +'"]').checked = false;
                var newLink = that.addUrlParams();
                that.loadBuffer();
                that.makeRequest('GET', newLink, '', that.loadNewEntries);
            });
        });

        if(that.yearButton.classList.contains('active') || that.topicButton.classList.contains('active'))
            that.mobileFilterToggle.classList.add('active');
        else
            that.mobileFilterToggle.classList.remove('active');*/
  }
};
